import {useCallback} from 'react';
import type {NationalAgent, NationalAgentType} from 'services/agent/types';
import {
  useGetAgentsByNationalIdMutation,
  useSearchAgentInNationalRegistryMutation,
} from 'services/agent';

export const useSearchAgentInNationalRegistry = (): ((
  agentType: NationalAgentType,
  name: string | undefined,
  other: string | undefined,
) => Promise<{hits: NationalAgent[]; inEbba: NationalAgent[]}>) => {
  const [searchInRegistry] = useSearchAgentInNationalRegistryMutation();
  const [getByNationalId] = useGetAgentsByNationalIdMutation();

  const handleSearch = useCallback(
    (
      agentType: NationalAgentType,
      name: string | undefined,
      other: string | undefined,
    ) => {
      return searchInRegistry({
        agentType,
        name: name ?? '',
        other: other ?? '',
      })
        .unwrap()
        .then(hits => {
          const nationalIds = hits
            .map(hit => hit.nationalId)
            .filter(id => id) as string[];
          return getByNationalId(nationalIds)
            .unwrap()
            .then(ebbaAgents => {
              const hitsWithId = hits.map(hit => ({
                ...hit,
                id: ebbaAgents.find(
                  ebbaAgent => ebbaAgent.nationalId === hit.nationalId,
                )?.id,
              }));
              return {
                hits: hitsWithId,
                inEbba: ebbaAgents as NationalAgent[],
              };
            });
        });
    },
    [searchInRegistry, getByNationalId],
  );

  return handleSearch;
};
